module.exports = __webpack_public_path__ + "assets/img/teacher (29).d9f740c1.png";